import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ErrorMessage from "../Common/Components/ErrorMessage";
import Spinner from "../Common/Components/spinner";
import { machineHealthDataToHours, msToHours } from "../Common/Util_methods/format";
import MachineHealthChart from "../MachineHealth/MachineHealthChart"
import MdcChart from "./MdcChart";
import { getMdcDataSelector, loadingMdcDataSelector } from "./mdcSlice";
import { getOptionsSelector } from "../Common/Slices/optionSlice";

interface ChartWidgetProps{
    id:string;
    header:string;
    legendSeries:any[];
    updateLegendSeries:any;
}

interface ChartData{

}
const MdcChartWidget = (props:ChartWidgetProps) =>{
    const [chartData, updateChartData] = useState([]);
    const [totalData, updateTotalData] = useState([])
    const [dataProcessed, setDataProcessed] = useState(false);
    const mdcData = useSelector(getMdcDataSelector).mdcData;
    const loadingState = useSelector(loadingMdcDataSelector);

    const cumuDataAs = useSelector(getOptionsSelector).cumuDataAs;

    useEffect(()=>{
            if(mdcData != null && mdcData.length > 0){
                updateChartData(formatData())
                updateTotalData(mdcData)
            }else{
                updateChartData([])
                updateTotalData([])
            }
        setDataProcessed(true);
    }, [mdcData, cumuDataAs])

    useEffect(()=>{
        
        if(loadingState === "pending"){
            setDataProcessed(false);
        }
        if(loadingState === "rejected"){
            setDataProcessed(true);
        }
        if(loadingState === "fulfilled" && mdcData.length === 0){
            setDataProcessed(true);
        }
    },[loadingState])

    const formatData = () =>{
        let combined = [] as any[];
        if (mdcData != null) {
            if (mdcData.length > 0) {
                mdcData.forEach(obj => {
                    if (obj != null) {
                        if (obj.rawData != null) {
                            const appendedRawData = appendDataPoint(obj, obj.rawData)
                            combined = combined.concat(appendedRawData)
                        }
                        if (obj.chartData != null) {
                            const appendedChartData = appendDataPoint(obj, obj.chartData);
                            combined = combined.concat(appendedChartData)
                        }
                    }
                });
            }
        }
        return combined;
    }

    const getCumuDataAs = () => {
        if (cumuDataAs == "All time cumulative") {
            return "cumulativeValue";
        }
        else if (cumuDataAs =="Range cumulative") {
            return "rangeCumulativeValue";
        }
            return "numericValue"
    }

    const appendDataPoint = (seriesObj,objArr) =>{
        const appendedData = objArr.map((rawObj) => {
            let cumu_data_as = rawObj.cumulativeData ? getCumuDataAs() : "numericValue";
            let newObject = {...rawObj,
                [seriesObj.device + " " + seriesObj.header + " (" + seriesObj.unit + ")"]: rawObj[cumu_data_as],
                ["ts" + seriesObj.device + " " + seriesObj.header + " (" + seriesObj.unit + ")"]:new Date(rawObj.ts),
                seriesID: seriesObj.device + " " + seriesObj.header + " (" + seriesObj.unit + ")"
}

            if(seriesObj.chartData.length > 0){
                newObject.unit = seriesObj.unit;
            }

            return newObject;
        })
        return appendedData
    }

    if (!dataProcessed){
        return <Spinner text="data" />;
    }
    if (mdcData == null) {
        //proper error handling should be added with promise error response
        return (
            <ErrorMessage
                text={"Oops something went wrong, unable to get data."}
                id={props.id}
                header={props.header}
            />
        );
    }   

    if (mdcData != null && mdcData.length == 0) {
        return (
            <Fragment>
                <ErrorMessage
                text={"No data found for selected filters."}
                id={props.id}
                header={props.header}
                />
                <div style={{"visibility":"hidden"}}>
                    <MachineHealthChart id="interrupt-chart" chartData={chartData} totalData={totalData} updateLegendSeries={props.updateLegendSeries}/>
                </div>
            </Fragment>
        );
    }
    return <MdcChart id="mdc-chart" chartData={chartData} totalData={totalData} updateLegendSeries={props.updateLegendSeries}  />
}

export default MdcChartWidget;